import React, { useState, useEffect } from 'react'
import { Button, Col, Container, Row } from 'react-bootstrap';
import { Form, Schema } from 'rsuite';
import { Link, useNavigate } from 'react-router-dom';
import BoardApproval from './BoardApproval';
import BoardApprovalModal from './BoardApprovalModal';
import reinstatementService from '../../../../../services/Internal/Reinstatement/EF/efReinstatement.service';
import { useSelector } from 'react-redux';
import boardApprovalService from '../../../../../services/Internal/Reinstatement/EF/boardApproval.service';
import entityService from '../../../../../services/Internal/Staff/entity.service';
import LoadingSpinner from '../../../../Shared/GenericComponents/LoadingSpinner';
import Swal from 'sweetalert2';
import dayjs from "dayjs";
import FormEntityInformation from '../../../Shared/FormEntityInformation';

function BoardApprovalPage() {
    const [hasLoaded, setHasLoaded] = useState(false);
    const entityId = useSelector(x => x.currentApplicationEntityId)
    const reinstatementId = useSelector(x => x.currentApplicationId);
    const sectionId = 11;
    const [modalShow, setModalShow] = useState(false);
    const [isComplete, setIsComplete] = useState(false);
    const [isUserEditable, setIsUserEditable] = useState(true);
    const [gridData, setGridData] = useState([]);
    const [entityInfo, setEntityInfo] = useState(
        {
            lolaNum: null,
            entityName: '',
            licenseNumber: '',
            formType: "Engineering Firm Reinstatement",
            isIndividual: false,
            entityId: 0,
            applicationDate: "",
            currentSection: "Board/Staff Recommendations"
        }
    );
    const { BooleanType } = Schema.Types;
    const model = Schema.Model({
        isFirmVerifiedBySecretaryOfState: BooleanType().isRequired('This field is required'),
        areFirmSupervisingProfessionalsVerified: BooleanType().isRequired('This field is required'),
        areFirmRequiredSupervisingProfessionalQuizzesSubmitted: BooleanType().isRequired('This field is required'),
        areFirmDisciplinaryActionsChecked: BooleanType().isRequired('This field is required'),
        boardApproval: BooleanType().isRequired('This field is required')
    })

    const [formModel, setFormModel] = useState({
        reinstatementId: reinstatementId,
        boardApproval: null,
        dateCrte: null,
        deleted: false,
        entityId: entityId,
        isFirmVerifiedBySecretaryOfState: null,
        areFirmSupervisingProfessionalsVerified: null,
        areFirmRequiredSupervisingProfessionalQuizzesSubmitted: null,
        areFirmDisciplinaryActionsChecked: null,
        additionalComments: "",
        id: 0,
        userCrte: ""
    })
    const [boardApprovalSectionId, setBoardApprovalSectionId] = useState();
    const [modalData, setModalData] = useState({
        comments: "",
        dateCrte: new Date(),
        dateReceived: new Date(),
        dateSent: new Date(),
        deleted: false,
        id: 0,
        userCrte: "",
        boardMemberDecision: null,
        boardMember: {
            appointmentYear: 0,
            credentialSuffix: "",
            expirationYear: 0,
            firstName: "",
            id: 0,
            lastName: "",
            middleName: "",
            representation: "",
            suffix: ""
        },
        entityId: entityId,
        reinstatementId: reinstatementId,
        boardStaffApprovalId: 0,
        files: [],
        filesForDisplay: [],
        filesLoading: false
    })

    useEffect(() => {
        reinstatementService.efGetSection(reinstatementId, sectionId).then((response) => {
            boardApprovalService.getBoardRecommendations(reinstatementId).then((data) => {
                setFormModel(data.data);
                setModalData({ ...modalData, boardStaffApprovalId: data.data.id })
                updateGrid()
                setIsComplete(response.data.staffReviewComplete);
                setBoardApprovalSectionId(response.data.id);
                reinstatementService.getFirmReinstatement(reinstatementId).then((data) => {
                    setIsUserEditable(data.data.status.id == 2)
                    entityService.getEntity(response.data.entityId).then((entity) => {
                        setEntityInfo(
                            {
                                ...entityInfo,
                                lolaNum: entity.data.lolaNumber,
                                entityName: entity.data.formattedName,
                                entityId: entity.data.entityId,
                                licenseNumber: data.data?.credential?.formattedLicenseNumber,
                                applicationDate: data.data?.dateSubmitted
                            })
                        setHasLoaded(true);
                    });
                });
            })
        })
    }, [])

    const updateGrid = () => {
        boardApprovalService.getBoardResponses(reinstatementId).then((vals) => {
            if (vals.data?.length)
                setGridData(
                    vals.data.map((value, i) => { return { ...value.boardMemberResponse, files: [...value.attachments] } }))
        })
    }
    const submitData = (val) => {
        if (val) {
            boardApprovalService.postBoardRecommendation(formModel).then((val) => {
                if (val.data) {
                    reinstatementService.efMarkSectionComplete(reinstatementId, sectionId, isComplete).then((data) => {
                        if (data.data)
                            Swal.fire("Saved", "Board/Staff approvals have been saved!", "success");
                    })
                }
            })
        }
    }

    const openAddEditModal = (values) => {
        if (values.id) {
            setModalData({ ...values, dateReceived: values.dateReceived != null ? dayjs(values.dateReceived).format('YYYY-MM-DD') : null, dateSent: values.dateSent != null ? dayjs(values.dateSent).format('YYYY-MM-DD') : null })
        }
        else {
            setModalData({
                comments: "",
                dateCrte: new Date(),
                dateReceived: null,
                dateSent: null,
                deleted: false,
                id: 0,
                userCrte: "",
                boardMemberDecision: null,
                boardMember: null,
                entityId: entityId,
                reinstatementId: reinstatementId,
                boardStaffApprovalId: formModel.id,
                files: [],
                filesForDisplay: []

            })
        }
        setModalShow(true);
    }

    return (
        <div>
            <Container fluid>
                {hasLoaded ? <>
                    <BoardApprovalModal approvals={gridData} updateGrid={updateGrid} modalData={modalData} show={modalShow} onHide={() => setModalShow(false)} />
                    <Form fluid formValue={formModel} model={model} onChange={formModel => setFormModel(formModel)} onSubmit={submitData}>
                        <FormEntityInformation {...entityInfo} />
                        <BoardApproval
                            isUserEditable={isUserEditable}
                            openModal={openAddEditModal}
                            setGridData={setGridData}
                            gridData={gridData}
                            sectionId={sectionId}
                            sectionDataId={boardApprovalSectionId}
                            entityId={entityId}
                            parentId={reinstatementId}
                        />
                        <Container fluid>
                            <Row className="mt-3">
                                <Col style={{ display: "flex", alignItems: "center" }}>
                                    <label className="switch">
                                        <input id="completeSectionCheckbox" checked={isComplete} onChange={() => { if (isUserEditable) setIsComplete(!isComplete); }} type="checkbox" />
                                        <span className="slider round"></span>
                                    </label>&nbsp;
                                    <label htmlFor="completeSectionCheckbox">
                                        <b>Mark Section as Complete</b>
                                    </label>
                                    &nbsp;&nbsp;
                                    <Button name="backToSections" as={Link} to="/internal/efreinstatement/sections" variant="primary" className="me-2">Back to Sections</Button>
                                    {isUserEditable &&
                                        <Button name="save" type="submit" variant="danger" className="me-2">Save</Button>
                                    }
                                </Col>
                            </Row>
                        </Container>
                    </Form>
                </> : <LoadingSpinner />
                }
            </Container>
        </div>
    );
}
export default BoardApprovalPage